/**
 * Maps backend errors from `api.slack.custom.workspace.save()` to friendly messages.
 *
 * The backend re-throws Slack's `tooling.tokens.rotate` error verbatim
 * (`tooling.tokens.rotate failed: <code>`). The most common reason a save
 * fails is an expired refresh token — we surface that as a clear, actionable
 * message instead of leaking the raw Slack code.
 */
export function friendlySlackTokenError(err: unknown): string {
  const raw = err instanceof Error ? err.message : String(err ?? "");
  const lower = raw.toLowerCase();

  if (
    lower.includes("token_expired") ||
    lower.includes("expired_token") ||
    lower.includes("expired refresh") ||
    lower.includes("token_revoked") ||
    lower.includes("invalid_auth") ||
    lower.includes("not_authed")
  ) {
    return (
      "That refresh token has expired or been revoked. Generate a new one at " +
      "api.slack.com/apps (profile menu → App configuration tokens) and paste it here."
    );
  }

  return raw || "Couldn't link your Slack workspace.";
}
